/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {Api404ContextService, findHttp404Response} from './api-404-context.service';
import {StateService} from '@uirouter/core';

@Injectable({
  providedIn: 'root'
})
export class AdnApi404NavigationService {
  constructor(
    private readonly api404Context: Api404ContextService,
    private readonly $state: StateService
  ) {
  }

  findHttp404Response(rejection: any): any {
    return findHttp404Response(rejection);
  }

  go(rejection: any): any {
    this.api404Context.setRejection(rejection);
    return this.$state.go('app.errors.api404', {}, {location: false, inherit: false});
  }

  target(rejection: any): any {
    this.api404Context.setRejection(rejection);
    return this.$state.target('app.errors.api404', {}, {location: false, inherit: false});
  }
}
